export const ACCESS_CODE = 'ACCESS_CODE';
export const INVALID_ACCESS_CODE = 'INVALID_ACCESS_CODE';
export const NO_ACCESS_CODE = 'NO_ACCESS_CODE';
export const GATED_ADDRESS = 'GATED_ADDRESS';
export const ADDRESS = 'ADDRESS';
export const COMMUNICATION_ISSUE = 'COMMUNICATION_ISSUE';
export const ACCESS_DENIED_BY_DOORMAN = 'ACCESS_DENIED_BY_DOORMAN';
export const BUSINESS_IS_CLOSED = 'BUSINESS_IS_CLOSED';

export const ADDRESS_QUESTIONNAIRE = 'ADDRESS_QUESTIONNAIRE';
export const ADDRESS_NOT_ACCESSIBLE = 'ADDRESS_NOT_ACCESSIBLE';
export const PREFER_POD = 'PREFER_POD';

export const SINGLE_HOUSE = 'SINGLE_HOUSE';
export const APARTMENT_COMPLEX = 'APARTMENT_COMPLEX';
export const COMMERCIAL_BUILDING = 'COMMERCIAL_BUILDING';
export const ADDRESS_TYPE_WITHOUT_BUSINESS_HOURS = [APARTMENT_COMPLEX, SINGLE_HOUSE];
export const ADDRESS_TYPE_WITH_BUSINESS_HOURS = [COMMERCIAL_BUILDING];

export const DAY_IN_MILLISECONDS = 24 * 60 * 60 * 1000;
export const QUESTIONNAIRE_PROPERTIES = ['address_type', 'address_characteristic', 'delivery_reason'];

export const DELIVERY_ADDRESS = 'DELIVERY_ADDRESS';
export const DELIVERY_INSTRUCTION = 'DELIVERY_INSTRUCTION';
export const DELIVERY_PREFER_POD = 'DELIVERY_PREFER_POD';
export const DELIVERY_KEEP_ORIGINAL = 'DELIVERY_KEEP_ORIGINAL';

export const ADDRESS_AUTO_CORRECTED = 'ADDRESS_AUTO_CORRECTED';
export const ADDRESS_CORRECTED = 'ADDRESS_CORRECTED';
export const ADDRESS_FLAGGED = 'ADDRESS_FLAGGED';
export const ADDRESS_INVALID = 'ADDRESS_INVALID';
export const ADDRESS_MISSING_UNIT = 'ADDRESS_MISSING_UNIT';
export const invalidAddressReasons = [ADDRESS_FLAGGED, ADDRESS_INVALID];

export const INCIDENT_ADDRESS_CORRECTED = 'ADDRESS-CORRECTED';
export const INCIDENT_ADDRESS_AUTO_CORRECTED = 'ADDRESS-AUTO-CORRECTED';
export const INCIDENT_ADDRESS_FLAGGED = 'ADDRESS-FLAGGED';
export const INCIDENT_ADDRESS_INVALID = 'ADDRESS-INVALID-DAS';
export const INCIDENT_ADDRESS_MISSING_UNIT = 'ADDRESS-MISSING-UNIT';
export const invalidAddressIncidents = [INCIDENT_ADDRESS_INVALID, INCIDENT_ADDRESS_FLAGGED];

export const CHARACTERISTIC_HOUSE_GATED = 'HOUSE_GATED';
export const CHARACTERISTIC_GATED = 'GATED';
export const CHARACTERISTIC_HIGH_RISE = 'HIGH-RISE';

export const DRIVER_LOCATION_PIN_REFRESH_INTERVAL = 20000;
export const DRIVER_LOCATION_RADIUS_REFRESH_INTERVAL = 10000;

export const DEFAULT_REQUEST_ERROR_TEXT = 'Something went wrong. Please try again!';
export const RATE_LIMIT_ERROR_TEXT = 'Too many attempts. Please wait a few minutes and try again.';
